<template>
    <div class="c-chart-legend" :class="{['c-chart-legend--' + columns] : true}"
         v-bind:style="{ width: legendWidth + '%', marginTop: marginTop + 'px', marginBottom: marginBottom + 'px' }">
        <div class="u-d-flex" :class="{'u-flex-wrap' : theCurrentWidth <= 400}">
            <div class="c-chart-legend__column">
                <div class="u-d-inline-block">
                    <div v-for="(value, index) in columnOne" class="u-d-flex u-text-left">
                        <div class="c-chart-legend__item" v-bind:style="{ background: columnOneColours[index] }"></div>
                        {{columnOne[index]}}
                    </div>
                </div>
            </div>
            <div v-if="columns === 2 || columns === 3" class="c-chart-legend__column">
                <div class="u-d-inline-block">
                    <div v-for="(value, index) in columnTwo" class="u-d-flex u-text-left">
                        <div class="c-chart-legend__item" v-bind:style="{ background: columnTwoColours[index] }"></div>
                        {{columnTwo[index]}}
                    </div>
                </div>
            </div>
            <div v-if="columns === 3" class="c-chart-legend__column">
                <div class="u-d-inline-block">
                    <div v-for="(value, index) in columnThree" class="u-d-flex u-text-left">
                        <div class="c-chart-legend__item" v-bind:style="{ background: columnThreeColours[index] }"></div>
                        {{columnThree[index]}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'chart-legend',
        props: {
            columns: {
                type: Number,
                default: 2
            },
            legendWidth: {
                type: Number,
                default: 70
            },
            marginTop: {
                type: String,
                default: ''
            },
            marginBottom: {
                type: String,
                default: ''
            },
            values: {
                
            },
            colours: {
                type: Array,
                default: function () { return [
                    '#45BFFC',
                    '#3DF2C3',
                    '#CD5CD8',
                    '#EB1458',
                    '#7DD3F4',
                    '#94F7DB',
                    '#E18FEF',
                    '#F94B8A',
                    '#4A89E5',
                    '#EA7A68',
                    '#9A4CD9',
                    '#BF104F',
                    '#422960',
                    '#007180',
                    '#2ECE9D'
                ] }
            }
        },
        watch: {
            values() {
                this.render();
            },
        },
        computed: {
            ...mapGetters('windowWidth', ['theCurrentWidth']),
        },
        data: () => {
            return {
                columnOne: [],
                columnTwo: [],
                columnThree: [],
                columnOneColours: [],
                columnTwoColours: [],
                columnThreeColours: []
            }
        },
        methods: {
            render () {
                this.columnOne = [];
                this.columnTwo = [];
                this.columnThree = [];
                this.columnOneColours = [];
                this.columnTwoColours = [];
                this.columnThreeColours = [];

                if(this.columns === 1) {
                    for(var i = 0; i < this.values.length; i ++) {
                        this.columnOne.push(this.values[i]);
                        this.columnOneColours.push(this.colours[i]);
                    }
                }
                else if(this.columns === 3) {
                    for(var i = 0; i < this.values.length; i += 3) {
                        this.columnOne.push(this.values[i]);
                        this.columnOneColours.push(this.colours[i]);
                    }
                    for(var i = 1; i < this.values.length; i += 3) {
                        this.columnTwo.push(this.values[i]);
                        this.columnTwoColours.push(this.colours[i]);
                    }
                    for(var i = 2; i < this.values.length; i += 3) {
                        this.columnThree.push(this.values[i]);
                        this.columnThreeColours.push(this.colours[i]);
                    }
                }
                else {
                    for(var i = 0; i < this.values.length; i += 2) {
                        this.columnOne.push(this.values[i]);
                        this.columnOneColours.push(this.colours[i]);
                    }
                    for(var i = 1; i < this.values.length; i += 2) {
                        this.columnTwo.push(this.values[i]);
                        this.columnTwoColours.push(this.colours[i]);
                    }
                }
            }
        },
        mounted() {
            this.render();
        }
    }
</script>


// WEBPACK FOOTER //
// Legend.vue?32e71562